import type { IconSvgObject } from './types';

const CursorRemoveSelection02Icon: IconSvgObject = [
  ["path", { d: "M3.60001 4.03043L18.7174 9.84482C19.1034 9.99327 19.0909 10.5436 18.6986 10.6743L12.1395 12.8607C12.0078 12.9046 11.9046 13.0079 11.8607 13.1395L9.67432 19.6986C9.54355 20.0909 8.99324 20.1034 8.84479 19.7175L3.0304 4.60004C2.8933 4.24357 3.24354 3.89333 3.60001 4.03043Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 18.5L14 18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CursorRemoveSelection02Icon;
